module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/apelv2-0638dfad06bcce0df52423fe58f55831.jpg";